module.exports = __webpack_public_path__ + "img/lk-mode-credit-card-grey.c05d3652.svg";